import { Skeleton } from "@mui/material";
import { FC } from "react";
import { TableSkeletonProps } from "../../interfaceTypes";

export const ActiveCaseListingSkeleton: FC<TableSkeletonProps> = ({ noOfRows }) => (
  <>
    {new Array(noOfRows).fill(0).map((_, index) => (
      <Skeleton key={index} variant="text" height={62} sx={{ width: '100%', transform: 'none', marginBottom: '13px' }} />
    ))}
  </>
);